// src/pages/Settings/SettingsLayout.jsx
import { Outlet } from 'react-router-dom';
import { AppSidebar } from '../../components/AppSidebar/AppSidebar';
import SettingsTabs from '../../components/Tabs/SettingsTabs';
import { useCurrentUser } from '../../features/auth/api';
import './settings.scss';

export default function SettingsLayout() {
  const { data: apiUser, isLoading: userLoading } = useCurrentUser();
  const isAdmin =
    apiUser?.type === 'ORG_OWNER' || apiUser?.type === 'ORG_USER' || apiUser?.type === 'ORG_ADMIN';
  const userItems = [
    { to: '/settings/profile', label: 'Profile' },
    { to: '/settings/password', label: 'Password' },
    { to: '/settings/addresses', label: 'Addresses' },
    { to: '/settings/notifications', label: 'Notifications' },
  ];
  const adminItems = [
    { to: '/settings/profile', label: 'Profile' },
    { to: '/settings/password', label: 'Password' },
  ];
  return (
    <div className="layout">
      <AppSidebar />
      <div className="layout__content">
        <header className="settings-header">
          <div>
            <h1 className="settings-header__title">Settings</h1>
            <p className="settings-header__subtitle">Manage your account and system preferences</p>
          </div>
        </header>

        <SettingsTabs items={!userLoading ? (isAdmin ? adminItems : userItems) : []} />

        <section className="settings-body">
          <Outlet />
        </section>
      </div>
    </div>
  );
}
